import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import apiClient from './../api/apiClient';
import { API_URLS } from './../api/apiUrls';
import { getGlobalLoadingSetter } from '../utils/axiosConfig'; 

export const useApi = () => {
  const [loading, setLoadingLocal] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  // obtener setLoading global del FullScreenLoader
  const setLoadingGlobal = getGlobalLoadingSetter();

  const buildUrl = useCallback((key, params = {}) => {
    const urlOrFunc = API_URLS[key];
    if (!urlOrFunc) throw new Error(`API_URLS no tiene la clave '${key}'`);

    if (typeof urlOrFunc === 'function') {
      const id = params.urlParams?.id ?? params.id;
      return urlOrFunc(id, params);
    }

    return urlOrFunc;
  }, []);

  const baseRequest = useCallback(async ({
    method,
    urlKey,
    urlParams = {},
    data: body = null,
    headers = {},
    params = null,
    successMessage,
    errorMessage = 'Ocurrió un error',
    showSuccess = false,
    showError = true,
    ...options
  }) => {
    setLoadingLocal(true);
    if (setLoadingGlobal) setLoadingGlobal(true);

    setError(null);

    try {
      const url = buildUrl(urlKey, urlParams);
      const response = await apiClient({ method, url, data: body, params, headers, ...options });

      setData(response.data);

      if (showSuccess && successMessage) {
        toast.success(successMessage);
      }

      return response.data;
    } catch (err) {
      setError(err);

      if (showError) {
        const msg = err.response?.data?.message || errorMessage;
        toast.error(msg);
      }

      throw err;
    } finally {
      setLoadingLocal(false);
      if (setLoadingGlobal) setLoadingGlobal(false);
    }
  }, [buildUrl, setLoadingGlobal]);

  const get = useCallback((urlKey, options = {}) => baseRequest({ method: 'get', urlKey, ...options }), [baseRequest]);
  const post = useCallback((urlKey, data, options = {}) => baseRequest({ method: 'post', urlKey, data, ...options }), [baseRequest]);
  const put = useCallback((urlKey, data, options = {}) => baseRequest({ method: 'put', urlKey, data, ...options }), [baseRequest]);
  const patch = useCallback((urlKey, data, options = {}) => baseRequest({ method: 'patch', urlKey, data, ...options }), [baseRequest]);
  const del = useCallback((urlKey, options = {}) => baseRequest({ method: 'delete', urlKey, ...options }), [baseRequest]);

  return {
    loading,   // loader local si quieres usarlo aparte
    error,
    data,
    get,
    post,
    put,
    patch,
    delete: del,
  };
};
